
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';

/*Components*/
import SelectBox from '../formComponents/selectBox';
import Input from '../formComponents/input';
import VideoPlayer from '../common/video';

import UploadImageFileAWS from '../../services/upload/awsHelper';
import ImageUploader from '../../services/upload/imageUploader';
/*Assets*/

class BannerContent extends Component {
  constructor(props){
    super(props);
    this.state = {
      tabIndex: 1,
      data: this.props.data,
      filesArray: [],
      error: ""
    }
  }

  componentDidMount() {
    var noOfFiles = this.props.data.bannerStyle.noOfFiles;
    var filesArray = [];
    for (var i = noOfFiles - 1; i >= 0; i--) {
      filesArray.push({
        file: '',
        fileURL: '',
        fileName: '',
        website: '',
        contentType: '',
      })
    }
    this.setState({filesArray})
  }

  async nextStepClick(){

    
    this.setState({error: ""});

    var error = "";

    await this.state.filesArray.map(function(item, index){
      if(!item.fileURL.length){
        error = "All banners are mandatory. Please upload and try again";
      }
    });


    if(!error.length){
      this.props.save(this.state.filesArray, this.state.data.bannerStyle);
    }
    else{
      this.setState({error: error});
    }
    
  }

  tabItemClick(tempItem){
    this.setState({tabIndex: tempItem});
  }

  websiteChange(website, index){
    var filesArray = this.state.filesArray;
    var tempData = filesArray[index];
    tempData['website'] = website;
    filesArray[index] = tempData;
    this.setState({filesArray: filesArray});
  }

  openFileExplorer(index){
    $("#fileInput"+index).click()
  }

  async fileChanged(index, e){
    // console.log(e)
    // console.log(index)
    var file = e.target.files[0];
    console.log(file)

    var fileName = file.name;
    var fileType = file.type

    var response = await UploadImageFileAWS(fileName, 'ads/files/', file, fileType)

    console.log(response)

    var filesArray = this.state.filesArray;
    var tempData = filesArray[index];
    tempData['file'] = file;
    tempData['fileName'] = file.name;
    filesArray[index] = tempData;
    this.setState({filesArray: filesArray});
    
  }

  uploadSucess(url, data, index){
    var filesArray = this.state.filesArray;
    var tempData = filesArray[index];
    tempData['file'] = true;
    tempData['fileName'] = data.fileName;
    tempData['contentType'] = data.type
    tempData['fileURL'] = url;
    filesArray[index] = tempData;
    this.setState({filesArray: filesArray});
  }

  render() {
    var tempClass = "";
    if(this.props.data.bannerStyle.id == 1){
      tempClass = "col-lg-12 mb-3"
    }
    else if(this.props.data.bannerStyle.id == 2 || this.props.data.bannerStyle.id == 9){
      tempClass = "col-lg-6 mb-3"
    }
    else if(this.props.data.bannerStyle.id == 3){
      tempClass = "col-lg-4 mb-3"
    }
    else if(this.props.data.bannerStyle.id == 4 || this.props.data.bannerStyle.id == 7 || this.props.data.bannerStyle.id == 8 || this.props.data.bannerStyle.id == 9){
      tempClass = "col-lg-3 mb-3"
    }

    var fileTypes = "";
    var fileTypePlaceholder = "";
    var contentIds = [1,2,3];
    if(contentIds.includes(1)){
      fileTypes = fileTypes + "image/png, image/jpg"
      fileTypePlaceholder = fileTypePlaceholder + ".png, .jpg"
    }
    if(contentIds.includes(2)){
      if(fileTypes.length){
        fileTypes = fileTypes + ", video/*"  
        fileTypePlaceholder = fileTypePlaceholder + ", .mp4"
      }else{
        fileTypes = fileTypes + "video/*"
        fileTypePlaceholder = fileTypePlaceholder + ".mp4"
      }
      
    }
    if(contentIds.includes(3)){
       if(fileTypes.length){
        fileTypes = fileTypes + ", image/gif"  
        fileTypePlaceholder = fileTypePlaceholder + ", .gif"
      }else{
        fileTypes = fileTypes + "image/gif"
        fileTypePlaceholder = fileTypePlaceholder + ".gif"
      }
    }
    var filesArray = this.state.filesArray;
    return (

        <div>
          <div className="row pt-3">
            <div className={
              this.props.data.bannerStyle.id == 4 || 
              this.props.data.bannerStyle.id == 8 || 
              this.props.data.bannerStyle.id == 7 ||
              this.props.data.bannerStyle.id == 5 ||
              this.props.data.bannerStyle.id == 6 ? "col-lg-12" : "col-lg-10"}>
              <div className="e-edit-ad e-banner-upload">
                {
                  this.props.data.bannerStyle.id == 5 ?
                    <div className="row">
                      <div className="col-lg-8">
                        <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                          <div className="e-bannercontent e-ad-5-l-banner">
                          {
                              filesArray.length && filesArray[0].fileURL ?
                                <div className="e-ad-banner-upload-preview">
                                  <span className="e-close-icon" onClick={(tempVal) => {
                                    var tempArry = this.state.filesArray;
                                    tempArry[0] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                    this.setState({filesArray: tempArry});
                                  }}></span>
                                  {
                                    filesArray[0].fileURL.indexOf(".mp4") > -1 ?
                                      <VideoPlayer url={filesArray[0].fileURL}  width="200px"/>
                                    :
                                      <img className src={filesArray[0].fileURL}/>
                                  }
                                  
                                </div>
                              : 
                                <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, 0)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                            }
                          </div>
                          <div className="pt-3 ">
                            <Input 
                              id="" 
                              type="text" 
                              defaultValue={filesArray.length ? filesArray[0].website : ""} 
                              valueChange={(tempVal) => this.websiteChange(tempVal, 0)} 
                              className="e-deal-link" placeholder="Add website link" 
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                            <div className="e-bannercontent e-ad-5-s-banner">
                            {
                              filesArray.length && filesArray[1].fileURL ?
                                <div className="e-ad-banner-upload-preview">
                                  <span className="e-close-icon" onClick={(tempVal) => {
                                    var tempArry = this.state.filesArray;
                                    tempArry[1] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                    this.setState({filesArray: tempArry});
                                  }}></span>
                                  {
                                    filesArray[1].fileURL.indexOf(".mp4") > -1 ?
                                      <VideoPlayer url={filesArray[1].fileURL} />
                                    :
                                      <img className src={filesArray[1].fileURL}/>
                                  }
                                  
                                </div>
                              : 
                                <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, 1)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                            }
                            </div>
                            <div className="pt-3 ">
                              <Input 
                                id="" 
                                type="text" 
                                defaultValue={filesArray.length ? filesArray[1].website : ""} 
                                valueChange={(tempVal) => this.websiteChange(tempVal, 1)} 
                                className="e-deal-link" placeholder="Add website link" 
                              />
                            </div>
                          </div>
                        </div>  
                        <div>
                          <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                            <div className="e-bannercontent e-ad-5-s-banner">
                            {
                              filesArray.length && filesArray[2].fileURL ?
                                <div className="e-ad-banner-upload-preview">
                                  <span className="e-close-icon" onClick={(tempVal) => {
                                    var tempArry = this.state.filesArray;
                                    tempArry[2] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                    this.setState({filesArray: tempArry});
                                  }}></span>
                                  {
                                    filesArray[2].fileURL.indexOf(".mp4") > -1 ?
                                      <VideoPlayer url={filesArray[2].fileURL} />
                                    :
                                      <img className src={filesArray[2].fileURL}/>
                                  }
                                  
                                </div>
                              : 
                                <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, 2)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                            }
                            </div>
                            <div className="pt-3 ">
                              <Input 
                                id="" 
                                type="text" 
                                defaultValue={filesArray.length ? filesArray[2].website : ""} 
                                valueChange={(tempVal) => this.websiteChange(tempVal, 2)} 
                                className="e-deal-link" placeholder="Add website link" 
                              />
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                            <div className="e-bannercontent e-ad-5-s-banner">
                            {
                              filesArray.length && filesArray[3].fileURL ?
                                <div className="e-ad-banner-upload-preview">
                                  <span className="e-close-icon" onClick={(tempVal) => {
                                    var tempArry = this.state.filesArray;
                                    tempArry[3] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                    this.setState({filesArray: tempArry});
                                  }}></span>
                                  {
                                    filesArray[3].fileURL.indexOf(".mp4") > -1 ?
                                      <VideoPlayer url={filesArray[3].fileURL} />
                                    :
                                      <img className src={filesArray[3].fileURL}/>
                                  }
                                  
                                </div>
                              : 
                                <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, 3)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                            }
                            </div>
                            {/* <div className="pt-3 ">
                              <Input 
                                id="" 
                                type="text" 
                                defaultValue={filesArray.length ? filesArray[3].website : ""} 
                                valueChange={(tempVal) => this.websiteChange(tempVal, 3)} 
                                className="e-deal-link" placeholder="Add website link" 
                              />
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <ImageUploader
                        className="pt-4 pb-3 e-upload-banner"
                        accept={fileTypes}
                        id={"fileInput0"}
                        index={0}
                        tempKey="ads/files"
                        uploadStatus={()=>{}}
                        uploadSucess={this.uploadSucess.bind(this)}
                      />
                      <ImageUploader
                        className="pt-4 pb-3 e-upload-banner"
                        accept={fileTypes}
                        id={"fileInput1"}
                        index={1}
                        tempKey="ads/files"
                        uploadStatus={()=>{}}
                        uploadSucess={this.uploadSucess.bind(this)}
                      />
                      <ImageUploader
                        className="pt-4 pb-3 e-upload-banner"
                        accept={fileTypes}
                        id={"fileInput2"}
                        index={2}
                        tempKey="ads/files"
                        uploadStatus={()=>{}}
                        uploadSucess={this.uploadSucess.bind(this)}
                      />
                      <ImageUploader
                        className="pt-4 pb-3 e-upload-banner"
                        accept={fileTypes}
                        id={"fileInput3"}
                        index={3}
                        tempKey="ads/files"
                        uploadStatus={()=>{}}
                        uploadSucess={this.uploadSucess.bind(this)}
                      />
                    </div>
                  : 
                    this.props.data.bannerStyle.id == 6 ?
                      <div className="row">
                        <div className="col-lg-4">
                          <div>
                            <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                              <div className="e-bannercontent e-ad-5-s-banner">
                                {
                                  filesArray.length && filesArray[0].fileURL ?
                                    <div className="e-ad-banner-upload-preview">
                                      <span className="e-close-icon" onClick={(tempVal) => {
                                        var tempArry = this.state.filesArray;
                                        tempArry[0] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                        this.setState({filesArray: tempArry});
                                      }}></span>
                                      {
                                        filesArray[0].fileURL.indexOf(".mp4") > -1 ?
                                          <VideoPlayer url={filesArray[0].fileURL} />
                                        :
                                          <img className src={filesArray[0].fileURL}/>
                                      }
                                      
                                    </div>
                                  : 
                                    <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, 0)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                                }
                              </div>
                              {/* <div className="pt-3 ">
                                <Input 
                                  id="" 
                                  type="text" 
                                  defaultValue={filesArray.length ? filesArray[0].website : ""} 
                                  valueChange={(tempVal) => this.websiteChange(tempVal, 0)} 
                                  className="e-deal-link" placeholder="Add website link" 
                                />
                              </div> */}
                            </div>
                          </div>  
                          <div>
                            <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                              <div className="e-bannercontent e-ad-5-s-banner">
                              {
                                filesArray.length && filesArray[1].fileURL ?
                                  <div className="e-ad-banner-upload-preview">
                                    <span className="e-close-icon" onClick={(tempVal) => {
                                      var tempArry = this.state.filesArray;
                                      tempArry[1] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                      this.setState({filesArray: tempArry});
                                    }}></span>
                                    {
                                      filesArray[1].fileURL.indexOf(".mp4") > -1 ?
                                        <VideoPlayer url={filesArray[1].fileURL} />
                                      :
                                        <img className src={filesArray[1].fileURL}/>
                                    }
                                    
                                  </div>
                                : 
                                  <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, 1)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                              }
                              </div>
                              <div className="pt-3 ">
                                <Input 
                                  id="" 
                                  type="text" 
                                  defaultValue={filesArray.length ? filesArray[1].website : ""} 
                                  valueChange={(tempVal) => this.websiteChange(tempVal, 1)} 
                                  className="e-deal-link" placeholder="Add website link" 
                                />
                              </div>
                            </div>
                          </div>  
                        </div>
                        <div className="col-lg-4">
                          <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                            <div className="e-bannercontent e-ad-6-l-banner">
                              {
                                filesArray.length && filesArray[2].fileURL ?
                                  <div className="e-ad-banner-upload-preview">
                                    <span className="e-close-icon" onClick={(tempVal) => {
                                      var tempArry = this.state.filesArray;
                                      tempArry[2] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                      this.setState({filesArray: tempArry});
                                    }}></span>
                                    {
                                      filesArray[2].fileURL.indexOf(".mp4") > -1 ?
                                        <VideoPlayer url={filesArray[2].fileURL} />
                                      :
                                        <img className src={filesArray[2].fileURL}/>
                                    }
                                    
                                  </div>
                                : 
                                  <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, 2)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                              }
                            </div>
                            {/* <div className="pt-3 ">
                              <Input 
                                id="" 
                                type="text" 
                                defaultValue={filesArray.length ? filesArray[2].website : ""} 
                                valueChange={(tempVal) => this.websiteChange(tempVal, 2)} 
                                className="e-deal-link" placeholder="Add website link" 
                              />
                            </div> */}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div>
                            <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                              <div className="e-bannercontent e-ad-5-s-banner">
                                {
                                  filesArray.length && filesArray[3].fileURL ?
                                    <div className="e-ad-banner-upload-preview">
                                      <span className="e-close-icon" onClick={(tempVal) => {
                                        var tempArry = this.state.filesArray;
                                        tempArry[3] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                        this.setState({filesArray: tempArry});
                                      }}></span>
                                      {
                                        filesArray[3].fileURL.indexOf(".mp4") > -1 ?
                                          <VideoPlayer url={filesArray[3].fileURL} />
                                        :
                                          <img className src={filesArray[3].fileURL}/>
                                      }
                                      
                                    </div>
                                  : 
                                    <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, 3)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                                }
                              </div>
                              <div className="pt-3 ">
                                <Input 
                                  id="" 
                                  type="text" 
                                  defaultValue={filesArray.length ? filesArray[3].website : ""} 
                                  valueChange={(tempVal) => this.websiteChange(tempVal, 3)} 
                                  className="e-deal-link" placeholder="Add website link" 
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                              <div className="e-bannercontent e-ad-5-s-banner">
                                {
                                  filesArray.length && filesArray[4].fileURL ?
                                    <div className="e-ad-banner-upload-preview">
                                      <span className="e-close-icon" onClick={(tempVal) => {
                                        var tempArry = this.state.filesArray;
                                        tempArry[4] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                        this.setState({filesArray: tempArry});
                                      }}></span>
                                      {
                                        filesArray[4].fileURL.indexOf(".mp4") > -1 ?
                                          <VideoPlayer url={filesArray[4].fileURL} />
                                        :
                                          <img className src={filesArray[4].fileURL}/>
                                      }
                                      
                                    </div>
                                  : 
                                    <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, 4)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                                }
                              </div>
                              {/* <div className="pt-3 ">
                                <Input 
                                  id="" 
                                  type="text" 
                                  defaultValue={filesArray.length ? filesArray[4].website : ""} 
                                  valueChange={(tempVal) => this.websiteChange(tempVal, 4)} 
                                  className="e-deal-link" placeholder="Add website link" 
                                />
                              </div> */}
                            </div>
                          </div>
                        </div>
                        <ImageUploader
                          className="pt-4 pb-3 e-upload-banner"
                          accept={fileTypes}
                          id={"fileInput0"}
                          index={0}
                          tempKey="ads/files"
                          uploadStatus={()=>{}}
                          uploadSucess={this.uploadSucess.bind(this)}
                        />
                        <ImageUploader
                          className="pt-4 pb-3 e-upload-banner"
                          accept={fileTypes}
                          id={"fileInput1"}
                          index={1}
                          tempKey="ads/files"
                          uploadStatus={()=>{}}
                          uploadSucess={this.uploadSucess.bind(this)}
                        />
                        <ImageUploader
                          className="pt-4 pb-3 e-upload-banner"
                          accept={fileTypes}
                          id={"fileInput2"}
                          index={2}
                          tempKey="ads/files"
                          uploadStatus={()=>{}}
                          uploadSucess={this.uploadSucess.bind(this)}
                        />
                        <ImageUploader
                          className="pt-4 pb-3 e-upload-banner"
                          accept={fileTypes}
                          id={"fileInput3"}
                          index={3}
                          tempKey="ads/files"
                          uploadStatus={()=>{}}
                          uploadSucess={this.uploadSucess.bind(this)}
                        />
                        <ImageUploader
                          className="pt-4 pb-3 e-upload-banner"
                          accept={fileTypes}
                          id={"fileInput4"}
                          index={4}
                          tempKey="ads/files"
                          uploadStatus={()=>{}}
                          uploadSucess={this.uploadSucess.bind(this)}
                        />
                      </div>
                  :
                    <div className="row">
                    {
                      this.state.filesArray.map((file, index)=>{
                        return(
                          <div className={tempClass}>
                            <div className="e-ad-dotted-border e-edit-schedule-ad p-3">
                              <div className="e-bannercontent">
                                
                                {
                                  file.fileName ?
                                    <div className="e-ad-banner-upload-preview">
                                      <span className="e-close-icon" onClick={(tempVal) => {
                                        var tempArry = this.state.filesArray;
                                        tempArry[index] = {file: "", fileURL: "", fileName: "", contentType: ""};
                                        this.setState({filesArray: tempArry});
                                      }}></span>
                                      {
                                        file.fileURL.indexOf(".mp4") > -1 ?
                                          <VideoPlayer url={file.fileURL} />
                                        :
                                          <img className src={file.fileURL}/>
                                      }
                                      
                                    </div>
                                  : 
                                    <span className="e-upload-btn e-banner-upload-btn" onClick={this.openFileExplorer.bind(this, index)}> Upload banner ({fileTypePlaceholder}). Max size 5MB</span>
                                }
                                <ImageUploader
                                  className="pt-4 pb-3 e-upload-banner"
                                  accept={fileTypes}
                                  id={"fileInput"+index}
                                  index={index}
                                  tempKey="ads/files"
                                  uploadStatus={()=>{}}
                                  uploadSucess={this.uploadSucess.bind(this)}
                                />
                                {
                                  // <p className="pt-4 pb-3 e-upload-banner" onClick={this.openFileExplorer.bind(this, index)}>Upload banner</p>
                                  // <input type="file" className="hidden" id={"fileInput"+index} onChange={this.fileChanged.bind(this, index)}/>  
                                }
                              </div>
                              {/* <div className="pt-3 ">
                                <Input id="" type="" className="e-deal-link" defaultValue={file.website} valueChange={(tempVal) => this.websiteChange(tempVal, index)} placeholder="Add website link" />
                              </div> */}
                            </div>
                          </div>
                        )
                      })
                    }
                    </div>
                }
                {
                  this.state.error.length ?
                    <div className="row pt-4">
                      <div className='col-lg-12'>
                        <p className="text-danger e-error">{this.state.error}</p>
                      </div>
                    </div>
                  :
                    null
                }
                
                <div className="row pt-4 pb-3 ml-1 align-items-center">
                <span className="btn-link mr-3" onClick={()=>this.props.back()}>
                    <span>←</span> Back to Previous Step
                </span>
                {
                  this.state.filesArray.length && this.state.filesArray[0].fileURL ?
                    <button className="e-s-btn" type="submit" onClick={this.nextStepClick.bind(this)} value="Submit">Save Banner</button>
                  :
                  <button className="e-s-btn e-inactive">Save Banner</button>
                }
                </div>
              </div>
            </div>
          </div>

        </div>

    );
  }
}

export default BannerContent;
